<template>
  <div>
    <Header :selectedApp="selectedApp"></Header>
    <div class="col-12 d-inline-flex">
      <div class="col-10 no-overflow ms-3 me-3 pt-3" style="position: relative;">
        <h2>Plisio Configurations</h2>

        <div class="d-flex justify-content-between align-items-center">
          <div class="d-flex justify-content-between align-items-center">
            <a role="button" class="procricket-btn mb-3" @click="redirectToCreate">Create New Entry</a>
          </div>
          <input
              type="text"
              class="form-control mb-3"
              placeholder="Search Plisio Configurations..."
              v-model="searchText"
              style="width: 20%; position: relative;"
          >
        </div>
        <div class="table-responsive">
          <table class="table table-striped table-bordered">
            <thead>
            <tr>
              <th class="col-1" @click="toggleSort('plisioConfigurationId')">plisioConfigurationId</th>
              <th class="col-1" @click="toggleSort('plisioName')">Plisio Name</th>
              <th class="col-1" @click="toggleSort('apiKey')">API Key</th>
              <th class="col-2" @click="toggleSort('redirectUrl')">Redirect URL</th>
              <th class="col-2" @click="toggleSort('callbackUrl')">Callback URL</th>
              <th class="col-2" @click="toggleSort('failInvoiceUrl')">Fail Invoice URL</th>
              <th class="col-1" @click="toggleSort('application')">Application</th>
              <th class="col-1" @click="toggleSort('active')">Active</th>
              <th class="col-1" @click="toggleSort('status')">Status</th>
              <th class="col-1">Edit</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="config in sortData" :key="config.plisioConfigurationId">
              <td class="col-1 text-truncate" v-html="truncateText(config.plisioConfigurationId, 30)" ></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.plisioName, 30)" @click="selectText" :data-text="config.plisioName"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.apiKey, 30)" @click="selectText" :data-text="config.apiKey"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.redirectUrl, 70)" :title="config.redirectUrl" @click="selectText" :data-text="config.redirectUrl"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.callbackUrl, 70)" :title="config.callbackUrl" @click="selectText" :data-text="config.callbackUrl"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.failInvoiceUrl, 70)" :title="config.failInvoiceUrl" @click="selectText" :data-text="config.failInvoiceUrl"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.application, 30)" @click="selectText" :data-text="config.application"></td>
              <td class="col-1 text-truncate">{{ config.active }}</td>
              <td class="col-1 text-truncate">{{ config.status }}</td>
              <td class="col-1 centered">
                <router-link :to="{ name: 'PlisioEdit', params: { id: config.plisioConfigurationId, ...config } }" class="procricket-btn">
                  Edit
                </router-link>
              </td>
            </tr>
            </tbody>
          </table>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import AdminService from "@/services/admin-service";
import Header from "@/components/Header.vue";
import Cookies from "js-cookie";

export default {
  name: "PlisioConfig",
  components: { Header },
  data() {
    return {
      searchText: "",
      plisioConfigList: [],
      sortColumn: "",
      sortDirection: "asc",
      selectedApp: "",
      highlightedElement: null,
    };
  },
  computed: {
    filteredPlisioConfigList() {
      const search = this.searchText.toLowerCase().trim();

      let filteredList = this.plisioConfigList.filter((config) => {
        return (
            (config.plisioName && config.plisioName.toLowerCase().includes(search)) ||
            (config.apiKey && config.apiKey.toLowerCase().includes(search)) ||
            (config.redirectUrl && config.redirectUrl.toLowerCase().includes(search)) ||
            (config.callbackUrl && config.callbackUrl.toLowerCase().includes(search)) ||
            (config.failInvoiceUrl && config.failInvoiceUrl.toLowerCase().includes(search)) ||
            (config.application && config.application.toLowerCase().includes(search))
        );
      });

      // sort
      if (this.sortColumn) {
        const direction = this.sortDirection === "asc" ? 1 : -1;
        filteredList = filteredList.sort((a, b) => {
          const rawA = a?.[this.sortColumn];
          const rawB = b?.[this.sortColumn];

          // handle booleans/numbers/strings safely
          const valueA = rawA === null || rawA === undefined ? "" : String(rawA).toLowerCase();
          const valueB = rawB === null || rawB === undefined ? "" : String(rawB).toLowerCase();

          if (valueA < valueB) return -1 * direction;
          if (valueA > valueB) return 1 * direction;
          return 0;
        });
      }

      // filter by application cookie if selected
      if (this.selectedApp !== "") {
        filteredList = filteredList.filter((item) => item.application === this.selectedApp);
      }

      return filteredList;
    },
    sortData() {
      return this.filteredPlisioConfigList;
    },
  },
  created() {
    this.doLoadPlisioConfig();
    document.addEventListener("click", (event) => this.handleClickAnywhere(event));

    const appCookie = Cookies.get("application");
    if (appCookie) this.selectedApp = appCookie;

    this.sortColumn = "plisioName";
  },
  beforeUnmount() {
    document.removeEventListener("click", (event) => this.handleClickAnywhere(event));
  },
  methods: {
    doLoadPlisioConfig() {
      // You need a backend endpoint similar to getPaypalConfigurationList()
      // Example naming:
      // AdminService.getPlisioConfigurationList()
      AdminService.getPlisioConfigurationList()
          .then((data) => {
            this.plisioConfigList = data;
          })
          .catch((error) => {
            console.error("Error loading Plisio configuration:", error);
          });
    },

    redirectToCreate() {
      this.$router.push({ name: "PlisioCreate" });
    },

    truncateText(text, limit) {
      if (text === undefined || text === null) return null;
      return text.length > limit ? text.substring(0, limit) + "..." : text;
    },

    async selectText(event) {
      const originalText = event.target.getAttribute("data-text");
      try {
        await navigator.clipboard.writeText(originalText);
        this.highlightElement(event.target);
      } catch (err) {
        console.error("Failed to copy text: ", err);
      }
    },

    highlightElement(element) {
      this.removeHighlight();
      element.style.backgroundColor = "yellow";
      this.highlightedElement = element;
      setTimeout(this.removeHighlight, 10000);
    },

    removeHighlight() {
      if (this.highlightedElement) {
        this.highlightedElement.style.backgroundColor = "";
        this.highlightedElement = null;
      }
    },

    handleClickAnywhere() {
      this.removeHighlight();
    },

    toggleSort(column) {
      if (this.sortColumn === column) {
        this.sortDirection = this.sortDirection === "asc" ? "desc" : "asc";
      } else {
        this.sortColumn = column;
        this.sortDirection = "asc";
      }
    },
  },
};
</script>

<style src="../../assets/style.css"></style>
